<ng-select
  [items]="items"
  [groupBy]="groupBy"
  [(ngModel)]="selectedId"
  (ngModelChange)="onModelChange()"
  [clearable]="clearable"
  [labelForId]="labelForId"
  [searchable]="searchable"
  [searchFn]="searchFn"
  [disabled]="disabled"

  bindLabel="label"
  bindValue="id"
>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    {{ item.label }}
    <ng-container *ngIf="item.description">
      <br>
      <span [title]="item.description" class="muted">{{ item.description }}</span>
    </ng-container>
  </ng-template>
</ng-select>
